export default "__VITE_ASSET__21d67011__"